import { AppointmentID } from "./Appointment";
import { DealerLocationID } from "./DealerLocation";
import { UserID } from "./User";

export type AppointmentStatusID = number;

export type AppointmentStatusHistoryID = number;

export type DefaultAppointmentStatusID = number;

export enum STATUS_IDENTIFIERS {
  CanceledStatus = -1,
  NewCarStatus = 1,
  CarCheckStatus = 2,
  PricingOKStatus = 3,
  CustomerOKStatus = 4,
  CarReadyStatus = 5,
  DiagnoseStatus = 6,
  AannameOKStatus = 7,
  CalculatingStatus = 8,
  ContactStatus = 9,
  CarCheckStartedStatus = 10,
  QualityCheckStatus = 11,
  CustomerAnsweredStatus = 12,
  BackOrder = 13,
  HandleCheckIn = 50,
  CheckInDone = 51,
  CarInShop = 52,
  CarOkPlusRepairOverivew = 53,
  QualityCheckPlusRepairOverview = 54,
  CarOutOfShop = 55,
  FakeLast = 55
}

export interface AppointmentStatus {
  created_on: string;
  updated_on: string;
  id: AppointmentStatusID;
  identifier: STATUS_IDENTIFIERS;
  name: string;
  icon: string;
  color: string;
  ordering: number;
  dealer_location_id: DealerLocationID;
}

export interface AppointmentStatusHistory {
  created_on: string;
  updated_on: string;
  id: AppointmentStatusHistoryID; // Claire Appointment Status History ID
  appointment_status_id: AppointmentStatusID;
  appointment_id: AppointmentID;
  user_id: UserID;
  is_dms: boolean; // The status was set by the DMS
  sa_remarks: string; // Remark when the status was set
  identifier: STATUS_IDENTIFIERS; // Status identifier, refer to that enumeration for more details
  last_user: string;
  assigned_mechanic_id: UserID | null;
  wo_nr: string | null;
  reg_nr: string | null;
}

export interface DefaultAppointmentStatus {
  id: DefaultAppointmentStatusID;
  color: string;
  icon: string;
  name: string;
  ordering: number;
  identifier: STATUS_IDENTIFIERS;
}
